export default __webpack_public_path__ + "static/media/ArrowPoint.ad1cca1f.svg";